import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { Card as CardComponent } from 'b2b-components/theme/components/CMS/Card';
import { isEmpty } from 'b2b-apps/shop/common/utils/empty/empty';
import { createKey } from 'b2b-apps/shop/common/utils/key/key';
import { AdditionalProps, ComponentType, Props } from './';

const Card: ComponentType = ({
  className,
  componentData,
  handleClick,
}: Props): ReactElement | null => {
  const cardData = componentData.global__card && componentData.global__card.componentData;

  if (isEmpty(cardData) || !Array.isArray(cardData)) {
    return null;
  }

  const cards: ReactElement[] = cardData.map(
    (card: Record<string, any>, index: number) => {
      const additionalProps: AdditionalProps = {};

      if (card.mpt_id) {
        additionalProps.dataAttributes = {
          'data-mpt-id': card.mpt_id,
        };
      }

      return (
        <CardComponent
          {...additionalProps}
          title={card.heading}
          topHtmlText={card.top_text}
          bottomHtmlText={card.bottom_text}
          imageUrl={card.image ? card.image.url : undefined}
          videoUrl={card.video_url || undefined}
          cta={{
            text: card.text_on_cta_button,
            url: card.cta_url,
          }}
          onCtaClick={handleClick}
          size={card.size}
          key={createKey('card', index)}
        />
      );
    },
  );
  return (
    <div className={classNames(className)}>
      {componentData.group_label && (
        <h2 className="cds-cms-SectionTitle">{componentData.group_label}</h2>
      )}
      <div className="cds-cms-GridRow">
        <div className="cds-cms-ModuleContainer">
          <div className="cds-cms-GridRow">{cards}</div>
        </div>
      </div>
    </div>
  );
};

export { Card };
